import React from 'react';
import classNames from 'classnames';
import { withInjectedProps } from '../InjectedPropsContext';
import { FaCheck as IconCheck } from 'react-icons/fa';
import './Checkbox.scss';
import { ComponentWithOwnLabel } from 'Components/Core/types';

export type ICheckboxProps = Pick<
  React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
  'defaultValue' | 'disabled' | 'name' | 'onChange' | 'onKeyDown'
> & {
  focusRef?: React.Ref<HTMLInputElement>;
  inGrid?: boolean;
  label?: string;
  value?: any;
};

const CheckboxBase: ComponentWithOwnLabel<ICheckboxProps> = ({
  defaultValue,
  disabled,
  focusRef,
  inGrid,
  label,
  name,
  onChange,
  onKeyDown,
  value,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      (event as any).data = { name, value: event.target.checked, submitValues: true };
      onChange?.(event);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && !event.defaultPrevented) {
      (event as any).data = { name, value: !(event.target as HTMLInputElement).checked, submitValues: true };
      onChange?.(event as any);
    }
    onKeyDown?.(event);
  };

  const theLabel = inGrid ? null : label;

  return (
    <span className={classNames('Checkbox', { 'Checkbox-disabled': disabled, 'Checkbox-noLabel': !theLabel })}>
      <label>
        <input
          checked={value === undefined ? undefined : !!value}
          defaultChecked={defaultValue === undefined ? undefined : !!defaultValue}
          className="Checkbox-Input"
          disabled={disabled}
          name={name}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          readOnly
          type="checkbox"
          ref={focusRef}
        />
        <span className="Checkbox-Inner">
          <span className="Checkbox-Box">
            <IconCheck className="Checkbox-Check" />
          </span>
          {theLabel}
        </span>
      </label>
    </span>
  );
};

CheckboxBase.managesOwnLabel = true;

const Checkbox = withInjectedProps(CheckboxBase);

export { Checkbox, CheckboxBase };
export default Checkbox;
